if (!customElements.get('ala-sticky-purchase')) {
  customElements.define('ala-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.root);
      this.original = this.root?.querySelector('.ap-submit');
      if (!this.original) return;
      this.button = this.querySelector('[data-sticky-submit]');
      this.variant = this.root.querySelector('[data-variant]');
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.sync = () => {
        this.button.textContent = this.original.textContent;
        this.button.disabled = this.original.disabled;
        const size = this.variant?.selectedOptions[0]?.textContent.trim() || '';
        const price = this.root.querySelector('[data-price]')?.textContent.trim() || '';
        this.querySelector('[data-sticky-variant]').textContent = [size, price].filter(Boolean).join(' · ');
      };
      this.button.addEventListener('click', () => {
        // Reuse the original form: variant, quantity and gift properties remain intact.
        const form = this.original.form;
        if (!form.checkValidity()) {
          form.querySelector(':invalid')?.scrollIntoView({block:'center'});
          form.reportValidity();
          return;
        }
        this.original.click();
      }, options);
      this.root.addEventListener('change', this.sync, options);
      this.mutation = new MutationObserver(this.sync);
      this.mutation.observe(this.original, {attributes:true,childList:true,subtree:true,characterData:true});
      this.updateVisibility = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.hidden = this.original.getBoundingClientRect().bottom > 0;
        });
      };
      window.addEventListener('scroll', this.updateVisibility, {...options, passive:true});
      window.addEventListener('resize', this.updateVisibility, options);
      this.observer = new IntersectionObserver(this.updateVisibility);
      this.observer.observe(this.original);
      this.updateVisibility();
      this.priceObserver = new MutationObserver(this.sync);
      const price = this.root.querySelector('[data-price]');
      if (price) this.priceObserver.observe(price, {childList:true,subtree:true,characterData:true});
      this.sync();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.priceObserver?.disconnect();
      this.mutation?.disconnect();
    }
  });
}
